/**
 * Was die installierte App von sich aus sagt: die Seite, die erscheint, wenn der Server nicht zu
 * erreichen ist (`offline/main.ts`, das kein Vue hat und diesen Teil deshalb direkt liest), und der
 * Hinweis auf eine neue Version (`AppUpdatePrompt.vue`). Ihre Zeilen unter „Lokale Daten“ sind
 * `account.privacy.app`.
 */
export default {
	pwa: {
		offline: {
			title: "Keine Verbindung",
			message:
				"Notitia konnte den Server nicht erreichen. Prüfen Sie Ihre Verbindung — diese Seite versucht es von selbst erneut, sobald Sie wieder online sind.",
			retry: "Erneut versuchen",
		},
		update: {
			available: "Eine neue Version von Notitia ist verfügbar",
			reload: "Neu laden",
			dismiss: "Schließen",
		},
	},
};
